module.exports = __webpack_public_path__ + "img/RB.1d269538.png";